import React, { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { ChangeHighlighter, FormattedNumberInput, Loading } from '@rd-web-markets/shared/dist/util';
import { isValueDefined } from '@rd-web-markets/shared/dist/util/helpers/is_value_defined';
import offerInvoicesService from '../../services/offer_invoices.service';
import projectContractorsService from '@rd-web-markets/de/dist/services/project_contractor.service';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
const InvoiceForm = _ref => {
  let {
    financialYear,
    deleteOfferInvoice,
    offerInvoice,
    handleOfferInvoiceChange,
    setSelectedContractor,
    contractor,
    invoiceIndex,
    applicationSubmitted
  } = _ref;
  const {
    t
  } = useTranslation();
  const [savedStatus, setSavedStatus] = useState('');
  const saveInvoiceChange = useErrorHandling(useCallback(async offerInvoice => {
    if (!offerInvoice.invoice_date) return;
    const updatedInvoice = await offerInvoicesService.update(financialYear.id, offerInvoice);
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    handleOfferInvoiceChange(updatedInvoice, invoiceIndex);
    setSavedStatus('saved');
  }, [contractor, financialYear, handleOfferInvoiceChange, invoiceIndex, setSelectedContractor]));
  const toggleIncludeInTotal = async e => {
    if (!offerInvoice.invoice_date) return;
    const updatedInvoice = await offerInvoicesService.update(financialYear.id, {
      ...offerInvoice,
      include_in_total: e.target.checked
    });
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    handleOfferInvoiceChange(updatedInvoice, invoiceIndex);
    setSavedStatus('saved');
  };
  const changeInvoice = (changedData, invoiceIndex) => {
    handleOfferInvoiceChange(changedData, invoiceIndex);
    setSavedStatus('not_saved');
  };
  if (!offerInvoice) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex pb-2"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      width: '180px'
    }
  }, "Invoice ", invoiceIndex + 1), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteButton, {
    variant: "danger",
    size: "sm",
    className: "text-white ms-3",
    disabled: applicationSubmitted,
    onClick: () => deleteOfferInvoice(offerInvoice.id)
  })), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: e => changeInvoice({
      ...offerInvoice,
      [e.target.name]: e.target.value
    }, invoiceIndex),
    onBlur: () => saveInvoiceChange(offerInvoice),
    object: offerInvoice,
    name: "cost",
    type: "text",
    disabled: applicationSubmitted,
    size: "sm",
    className: "me-4 ms-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: applicationSubmitted,
    selected: offerInvoice.invoice_date,
    onChange: date => saveInvoiceChange({
      ...offerInvoice,
      invoice_date: date
    })
  }), /*#__PURE__*/React.createElement("p", null, offerInvoice.invoice_date === null ? t('enter_date_to_save') : t(savedStatus))), /*#__PURE__*/React.createElement(Form.Check, {
    checked: offerInvoice.include_in_total && isValueDefined(offerInvoice.cost),
    value: !!offerInvoice.include_in_total,
    name: "include_in_total",
    onChange: toggleIncludeInTotal,
    disabled: !isValueDefined(offerInvoice.cost) || applicationSubmitted
  })));
};
export default InvoiceForm;